import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";
import { useStaffLayout } from "../../../Components/Context/CandidateLayoutContext";

function AdditionalRequirementList({ isAdmin }) {
  const navigate = useNavigate();

  const { privilegeData } = useStaffLayout();

  function hasaddreqAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("additional requirement");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasaddreqEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("additional requirement");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  const columns = [
    { field: "ARL_Id", label: "#" },
    { field: "ARL_Name", label: "Additional Requirement" },
    { field: "ARL_Status", label: "Status" },
  ];

  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const rowsPerPage = searchParams.get("rowsPerPage");

  const actions = [
    hasaddreqEditprivilege(privilegeData) && {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.ARL_Id));

        navigate(
          `/AdditionalRequirementsLookup/Edit/${encrypted}?page=${page}&rowsPerPage=${rowsPerPage}`
        );
      },
      color: "warning",
    },
  ].filter(Boolean);

  return (
    <DynamicTable
      columns={columns}
      dataAPI={`/AdditionalRe/list`}
      actions={actions}
      title={`Additional Requirements`}
      {...(hasaddreqAddprivilege(privilegeData) && {
        linkvalue: `/AdditionalRequirementsLookup/Add?page=${page}&rowsPerPage=${rowsPerPage}`,
      })}
    />
  );
}

export default AdditionalRequirementList;
